import {MenuItemSpec} from "./MenuItemSpec";
import React from "react";

export const MenuItemHeader = (spec: MenuItemSpec): React.ReactNode => {
	const {title, subtitle} = spec;
	const classBlock = 'dropdown';

	return (
		<React.Fragment>
			<h3 className={`${classBlock}__item-title`}>{title}</h3>
			{subtitle && (
				<p className={`${classBlock}__item-subtitle`}>{subtitle}</p>
			)}
		</React.Fragment>
	);
};